import { Route } from "react-router-dom";
import { TOS } from "./tos";

export const TOSRoutes = (): JSX.Element[] => {
    const TOSRoutes = [<Route path={'tos'} key={'tos'} element={<TOS />}/>];
    return TOSRoutes;
}